import { Get, Post, Delete } from '../helpers';
import { Document, CreateDocument } from '@/types/module.types';

export const GetDocuments = async (channel: number): Promise<Document[]> => {
  return Get({ path: `/v3/admin/channel/documents/${channel}` });
};

export const PostDocument = async (document: CreateDocument): Promise<Document> => {
  return Post({ url: '/v3/admin/channel/documents', body: { document } });
};

interface IConvertBody {
  document: number;
  ext: string;
  filename: string;
  prefix: string;
}
export const ConvertDocument = async (body: IConvertBody): Promise<void> => {
  return Post({ url: '/v3/admin/channel/documents/convert', body });
};

export const DeleteDocuments = (
  channel: number,
  documentIDs: number[]
): Promise<{ cannotDelete: number[]; deletedDocuments: number[] }> => {
  return Delete({ url: `/v3/admin/channel/documents`, body: { channel, documentIDs } });
};
